export default "__VITE_ASSET__D_sDqcfl__"